import { render } from "./EducationalTechnologyView.vue?vue&type=template&id=7dca929b&scoped=true"
import script from "./EducationalTechnologyView.vue?vue&type=script&lang=js"
export * from "./EducationalTechnologyView.vue?vue&type=script&lang=js"

import "./EducationalTechnologyView.vue?vue&type=style&index=0&id=7dca929b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dca929b"]])

export default __exports__